/*
 *
 * Login constants
 *
 */

const constantKey = 'app/containers/Login';

const loginConstants = {
  LOGIN_REQUEST: `${constantKey}/LOGIN_REQUEST`,
  LOGIN_SUCCESS: `${constantKey}/LOGIN_SUCCESS`,
  LOGIN_FAILURE: `${constantKey}/LOGIN_FAILURE`,
  LOGOUT: `${constantKey}/LOGOUT`,
  CHECK_AUTH: `${constantKey}/CHECK_AUTH`,
  REFRESH_TOKEN_REQUEST: `${constantKey}/REFRESH_TOKEN_REQUEST`,
  REFRESH_TOKEN_SUCCESS: `${constantKey}/REFRESH_TOKEN_SUCCESS`,
  REFRESH_TOKEN_FAILURE: `${constantKey}/REFRESH_TOKEN_FAILURE`,
  UPDATE_ACCESS_TOKEN: `${constantKey}/UPDATE_ACCESS_TOKEN`,
  DEFAULT_ACTION: `${constantKey}/DEFAULT_ACTION`,
  DEFAULT_ACTION_SUCCESS: `${constantKey}/DEFAULT_ACTION_SUCCESS`,
  DEFAULT_ACTION_ERROR: `${constantKey}/DEFAULT_ACTION_ERROR`,
};

export default loginConstants;
